import React from 'react';
import { motion } from 'framer-motion';
import { getIconColor, getIconSize } from '../../utils/iconMap';

/**
 * Admin / özet istatistik kartı — ikon + etiket + değer tek desende.
 */
export default function StatCard({ label, value, icon: Icon, colorKey, valueClassName, testId, index = 0, className = '' }) {
  const valueTone = valueClassName || getIconColor(colorKey);
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: Math.min(index * 0.04, 0.35) }}
      className={`glass-effect p-6 rounded-xl ${className}`.trim()}
      data-testid={testId}
    >
      <div className="flex items-center justify-between mb-3">
        <div className="text-sm text-gray-400">{label}</div>
        {Icon ? <Icon className={`${getIconSize('medium')} ${getIconColor(colorKey)}`} aria-hidden /> : null}
      </div>
      <div className={`text-3xl font-bold ${valueTone}`}>{value}</div>
    </motion.div>
  );
}
